import { render } from "./Video.vue?vue&type=template&id=189d98b2&scoped=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-189d98b2"

export default script